import { Injectable } from '@angular/core';
import { PagingConfig } from 'src/app/core/models/paging-config.model';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  private pagingConfigs = new Map<string, PagingConfig>();

  constructor() {}

  setPagingConfigValues(tableKey: string, values: PagingConfig) {
    this.pagingConfigs.set(tableKey, { ...values });
  }

  updatePagingConfigValue<K extends keyof PagingConfig>(
    tableKey: string,
    key: K,
    value: PagingConfig[K]
  ) {
    const config = this.pagingConfigs.get(tableKey) || ({} as PagingConfig);
    config[key] = value;
    this.pagingConfigs.set(tableKey, config);
  }
  getPagingConfigValues(tableKey: string): PagingConfig {
    return this.pagingConfigs.get(tableKey) || ({} as PagingConfig);
  }
}
